import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const REVIEWS = [
  { name: "Elif & Emre", place: "Çankaya", text: "Kendimizi hiç bu kadar doğal ve güzel görmemiştik. Kareler bir film gibi oldu." },
  { name: "Merve & Burak", place: "Gölbaşı", text: "Eymir Gölü'nde gün batımı çekimi harikaydı. Albüm tam 7 günde elimizdeydi." },
  { name: "Zeynep & Can", place: "Beypazarı", text: "Tarihi sokaklarda çok özel kareler çıktı. Süreç boyunca öyle ilgilendiler ki, herkese tavsiye ederiz." },
  { name: "Sude & Kerem", place: "Altındağ", text: "Hamamönü'nde çekildik, atmosfer muhteşemdi. Doğal yönlendirme sayesinde hiç zorlanmadık." },
  { name: "Nazlı & Ali", place: "Keçiören", text: "Estergon Kalesi çekimimiz çok beğenildi. Ekip çok profesyonel ve güler yüzlüydü." },
  { name: "Derya & Mert", place: "Kızılcahamam", text: "Çam ormanları arasında sinematik bir video çıktı. Kesinlikle değer." },
];

export const Testimonials = () => (
  <section className="section-pad bg-[#141517]">
    <div className="container-lux">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center">Değerlendirmeler</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
            Çiftlerimiz ne diyor?
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-[#D7B86A] text-[#D7B86A]" />
            ))}
            <span className="text-[#CFC6B8] ml-1">4.9/5 · Google değerlendirmeleri</span>
          </div>
        </div>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-12">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.06}>
            <figure className="h-full rounded-2xl border border-white/10 bg-[#1A1B1E] p-6">
              <Quote className="w-8 h-8 text-[#C8A24A]/60" />
              <blockquote className="font-display text-lg italic text-[#EDE7DA] mt-3 leading-relaxed">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-4 text-sm">
                <span className="text-[#F7F2E8] font-semibold">{r.name}</span>
                <span className="text-[#9A9387]"> · {r.place}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
